<template>
  <div class="mb-3">
    <v-layout wrap>
      <v-flex>
        <v-text-field
          v-model="userFilter"
          append-icon="search"
          label="Filter Users"
          single-line
          hide-details
        />
        <v-data-table
          :headers="headers"
          :items="userDataC"
          :search="userFilter"
          class="elevation-1"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item="props">
            <tr>
              <td class="justify-center">
                <v-btn v-if="props.item.userSeq" tooltip.hover title="Edit groups assigned to this user" icon class="mx-0" @click="editUser(props.item)">
                  <v-icon color="primary">edit</v-icon>
                </v-btn>
              </td>
              <td
                tooltip.hover title="Edit roles (OKTA groups) assigned to this user"
              >
                <router-link :to="{ path: '/okta-users', query: { login : props.item.userUID }}">{{ props.item.userUID }}</router-link>
              </td>
              <td>{{ props.item.fullName }}</td>
              <td>{{ props.item.email }}</td>
              <td>
                <span v-for="groupName in props.item.groups" :key="groupName">{{ groupName }}<br /></span>
              </td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.createdBy }}</td>
              <td>{{ props.item.createdOn | formatDate }}</td>
              <td>{{ props.item.lastOktaLogin | formatDate }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <manage-users-user-groups-modal />
  </div>
</template>

<script>
import ManageUsersUserGroupsModal from './ManageUsersUserGroupsModal'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import find from 'lodash/find'
export default {
  name: 'manage-users-by-user',
  components: {
    ManageUsersUserGroupsModal
  },
  props: {
    userData: Array,
    selectedUser: String
  },
  data() {
    return {
      userFilter: '',
      headers: [{
        text: 'Action',
        value: false,
        sortable: false
      }, {
        text: 'User ID',
        value: 'userUID'
      }, {
        text: 'Name',
        value: 'fullName'
      }, {
        text: 'Email',
        value: 'email'
      }, {
        text: 'Roles',
        value: 'groupsSort'
      }, {
        text: 'Status',
        value: 'status'
      },
      {
        text: 'Created By',
        value: 'createdBy'
      },
      {
        text: 'Created On',
        value: 'createdOn'
      },
      {
        text: 'Last Okta Login',
        value: 'lastOktaLogin'
      }
      ]
    }
  },
  computed: {
    ...mapGetters('oktaGroups', ['groupNames']),
    userDataC: function() {
      Object.keys(this.userData).forEach(key => {
        var user = this.userData[key]
        if (user.oktaUser && user.oktaUser.profile) {
          user.fullName = user.oktaUser.profile.lastName + ', ' + user.oktaUser.profile.firstName
          user.email = user.oktaUser.profile.email
          user.status = user.oktaUser.status
          user.lastOktaLogin = user.oktaUser.lastLogin
        }
        if (user.oktaUser && user.oktaUser.groupIds) {
          user.groups = this.groupNames(user.oktaUser.groupIds)
          user.groupsSort = user.groups.join(',')
        }
      })
      return this.userData
    }
  },
  created() {
    if (this.selectedUser) {
      const user = find(this.userData, v => v.userUID.toLowerCase() === this.selectedUser.toLowerCase())
      if (user) this.editUser(user)
    }
  },
  methods: {
    ...mapActions('manageUsers', ['getUserGroupsForUser', 'getUserGroupHistoryForUser']),
    ...mapMutations('manageUsers', ['setShowUsersModal']),
    editUser(user) {
      this.getUserGroupsForUser(user)
      this.getUserGroupHistoryForUser(user)
      this.setShowUsersModal(true)
    }
  }
}
</script>
